import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import {newFormatPrice} from '../../../../services/utilityFunctions';

const GlobalSummary = props => {
  const {t, data, showUserModal} = props;

  const {
    isActive,
    activeUntil,
    current5RollingWeekVA,
    activeVAGoal,
    currentCommissionPercentage,
    rightLegRollingVA,
    leftLegRollingVA,
    forecastRightLegVA,
    forecastLeftLegVA,
    nextPayout,
    lastWeekPayout,
    currencyInfo,
  } = data;

  return (
    <>
      <div
        className="grid-row"
        style={{gridTemplateColumns: 'repeat(3, 1fr)'}}
      >
        <div className="grid-item">
          <div className="card card-light-gray">
            <div className="summary-card">
              <div className="summary-media">
                <img
                  src="/images/reports/user-summary.svg"
                  alt="active"
                  className="summary-image"
                />
              </div>
              <div className="summary-content">
                <div className="summary-section">
                  <span className="summary-name">
                    {t('report.arcova.summary')}
                  </span>
                  <button
                    type="button"
                    className="btn m-btn--pill btn-all-users"
                    onClick={showUserModal}
                  >
                    {t('report.mivitana.seeAllUsers')}
                  </button>
                </div>
                <div className="summary-action">
                  <div className="summary-action-content">
                    <span className="summary-action-label">
                      {t('report.arcova.status')}
                    </span>
                    <label htmlFor="isActive" className="checkbox">
                      <input
                        id="isActive"
                        name="isActive"
                        type="checkbox"
                        className="summary-checkbox"
                        disabled
                        checked={isActive}
                      />
                      <label htmlFor="isActive" className="fakeCheckbox"/>
                      <span className="isActiveLabel">
                        {t('report.arcova.isActive')}
                      </span>
                    </label>
                  </div>
                  <div className="summary-action-content">
                    <div>
                      <span className="summary-action-label">
                        {t('report.arcova.activeUntil')}&nbsp;
                      </span>
                      <span className="summaryDate">
                        {activeUntil ? moment(activeUntil).format('DD MMMM YYYY') : 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
                {!isActive ? (
                  <div className="progress-section">
                    <div className="progress-bar-container">
                      <span className="progress-bar">
                        <span
                          className="progress"
                          style={{
                            width: `${
                              (current5RollingWeekVA / activeVAGoal) * 100
                            }%`,
                          }}
                        />
                      </span>
                      <span className="progress-text">
                        {current5RollingWeekVA}
                        <span className="goal">&nbsp;/{activeVAGoal} PV</span>
                      </span>
                    </div>
                    <div className="progress-hint">
                      {t('report.mivitana.makeAPurchase', activeVAGoal)}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="grid-item">
          <div className="card investment-levels">
            <div className="commission-percentage-card">
              <span className="small-text">
                <img
                  src="/images/reports/percentage.svg"
                  alt="active"
                  className="summary-image"
                />
                {t('report.mivitana.percentageCommission')}
              </span>
              <span className="bigger-text">
                {currentCommissionPercentage || 0}
                {t('report.mivitana.percentageWeakerLeg')}
              </span>
            </div>
          </div>
        </div>
        <div className="grid-item">
          <div className="card card-light-gray weekly-cap-card">
            <div className="card-body">
              <div className="d-flex">
                <div className="small-image-container">
                  <img
                    src="/images/reports/calendar.svg"
                    alt="active"
                    className="summary-image"
                  />
                </div>
                <span className="value-label weekly-capping">
                  {t('report.mivitana.currentPayout')}
                </span>
              </div>
              <span className="card-main-value">{`${newFormatPrice(
                nextPayout,
                true,
                currencyInfo.code,
              )}/${t('report.arcova.perWeek')}`}</span>
              <span className="card-secondary-value">{`${newFormatPrice(
                lastWeekPayout,
                true,
                currencyInfo.code,
              )} ${t('report.mivitana.lastWeek')}`}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="pv-summary">
        <div className="flex-row">
          <div className="flex-item orange-background">
            <div className="description">
              {t('report.mivitana.leftPV5RollingWeeks')}
            </div>
            <div className="value">{leftLegRollingVA || 0}</div>
          </div>
          <div className="flex-item blue-background">
            <div className="description">
              {t('report.mivitana.rightPV5RollingWeeks')}
            </div>
            <div className="value">{rightLegRollingVA || 0}</div>
          </div>
        </div>
        <div className="flex-row">
          <div className="flex-item orange-background">
            <div className="description">
              {t('report.mivitana.foreCastLeftPV5RollingWeeks')}
            </div>
            <div className="value">{forecastLeftLegVA || 0}</div>
          </div>
          <div className="flex-item blue-background">
            <div className="description">
              {t('report.mivitana.foreCastRightPV5RollingWeeks')}
            </div>
            <div className="value">{forecastRightLegVA || 0}</div>
          </div>
        </div>
      </div>
    </>
  );
};

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    userId: PropTypes.string,
    isActive: PropTypes.bool,
    activeUntil: PropTypes.number,
    activeVAGoal: PropTypes.number,
    current5RollingWeekVA: PropTypes.number,
    currentCommissionPercentage: PropTypes.number,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
    nextPayout: PropTypes.number,
    lastWeekPayout: PropTypes.number,
    rightLegRollingVA: PropTypes.number,
    leftLegRollingVA: PropTypes.number,
    forecastRightLegVA: PropTypes.number,
    forecastLeftLegVA: PropTypes.number,
  }).isRequired,
  showUserModal: PropTypes.func.isRequired,
};

export default translate(GlobalSummary);
